"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveSendSupportedFormats = void 0;
exports.LiveSendSupportedFormats = {
    MP4: 'MP4',
    M4V: 'M4V',
    AVI: 'AVI',
    MPG: 'MPG',
    MPA: 'MPA',
    MEP: 'MEP',
    RA: 'RA',
    RM: 'RM',
    RAM: 'RAM',
    WMV: 'WMV',
    ASF: 'ASF',
    MOV: 'MOV',
    VOB: 'VOB',
    _3GP: '3GP',
    V3GP: 'V3GP',
    MPEG4: 'MPEG4',
    YOUTUBE: 'YOUTUBE',
    VIMEO: 'VIMEO',
    MP3: 'MP3',
    URL: 'URL',
    JPG: 'JPG',
    JPEG: 'JPEG',
    PNG: 'PNG',
    GIF: 'GIF',
    PDF: 'PDF',
    PPT: 'PPT',
    PPTX: 'PPTX',
    DOC: 'DOC',
    DOCX: 'DOCX',
    XLSX: 'XLSX',
    XLS: 'XLS',
    XLSM: 'XLSM',
    GDOC: 'GDOC',
    GSLIDES: 'GSLIDES',
    KEY: 'KEY',
    MICROAPP: 'MICROAPP',
    ZIP: 'ZIP',
    HTMLARCHIVE: 'HTMLARCHIVEZIP',
};
//# sourceMappingURL=SeismicFormats.js.map